import { supabase } from "@/integrations/supabase/client";

export async function updateFreeQuota(userId: string, quotaType: 'document' | 'ai' | 'case'): Promise<void> {
  const quotaField = `free_${quotaType}_quota`;
  
  const { error } = await supabase
    .from('token_allocations')
    .update({ [quotaField]: supabase.rpc('increment_token_usage', { 
      p_user_id: userId,
      p_tokens_used: 1 
    })})
    .eq('user_id', userId);

  if (error) throw error;
}

export async function checkFreeQuota(userId: string, quotaType: 'document' | 'ai' | 'case'): Promise<boolean> {
  const { data, error } = await supabase
    .from('token_allocations')
    .select(`free_${quotaType}_quota`)
    .eq('user_id', userId)
    .maybeSingle();

  if (error) throw error;
  return data?.[`free_${quotaType}_quota`] > 0;
}